module.exports = __webpack_public_path__ + "static/logo-afe829fc651841c488249567a2219963.png";